// @ts-nocheck

export const PreviousPagesStateActionTypes = Object.freeze({
  SET_PREVIOUS_PAGE: 'PREVIOUS_PAGES:SET_PREVIOUS_PAGE',
  RESET_PREVIOUS_PAGE: 'PREVIOUS_PAGES:RESET_PREVIOUS_PAGE',
});
